import "./upcomingHearings.css";

export default function HearingCard({
  date,
  month,
  time,
  title,
  court,
}) {
  return (
    <div className="hearing-card">

      <div className="hearing-date">
        <h3>{date}</h3>
        <span>{month}</span>
      </div>

      <div className="hearing-content">
        <span className="hearing-time">{time}</span>

        <h4 title={title}>{title}</h4>

        <p title={court}>{court}</p>
      </div>

      <div className="hearing-tag">
        Hearing
      </div>

    </div>
  );
}